import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { injectIntl } from 'react-intl';
import UMOToolbar from './UMOToolbar';
import { SearchParams } from '../../utils/searchUtils';
import Pagination from '../Pagination';

function UMOGalleryHeader({
   mainTitle,
   isUMOGalleryWorkspace,
   sortBy,
   sortByIsDescending,
   dispatch,
   umoGalleryViewType,
   searchParams,
  selectedWorkspaceData,
  selectedUMOIDs,
  isSelectAll,
  copyUMOs,
  umoList,
  isSortMode,
  pageNumber,
  pageTotal,
  onPageChange,
  toggleCompareView,
  intl,
}) {
  return (
    <div className="umo-gallery-header">
      <div className="umo-gallery-header__lightbox">
        {mainTitle && <h3 className="umo-gallery-header__lightbox-name">{mainTitle}</h3>}
      </div>
      <Pagination
        pageNumber={pageNumber}
        pageTotal={pageTotal}
        onPageChange={onPageChange}
      />
      {!isSortMode ?
        <UMOToolbar
          dispatch={dispatch}
          sortBy={sortBy}
          sortByIsDescending={sortByIsDescending}
          umoGalleryViewType={umoGalleryViewType}
          searchParams={searchParams}
          selectedWorkspaceData={selectedWorkspaceData}
          selectedUMOIDs={selectedUMOIDs}
          isSelectAll={isSelectAll}
          isUMOGalleryWorkspace={isUMOGalleryWorkspace}
          copyUMOs={copyUMOs}
          umoList={umoList}
          isSortMode={isSortMode}
          toggleCompareView={toggleCompareView}
        /> : null
          }
    </div>
  );
}

UMOGalleryHeader.propTypes = {
  mainTitle: PropTypes.string,
  isUMOGalleryWorkspace: PropTypes.bool,
  sortBy: PropTypes.string,
  sortByIsDescending: PropTypes.bool,
  dispatch: PropTypes.func,
  umoGalleryViewType: PropTypes.string,
  searchParams: PropTypes.instanceOf(SearchParams),
  selectedWorkspaceData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  selectedUMOIDs: PropTypes.instanceOf(List),
  isSelectAll: PropTypes.bool,
  copyUMOs: PropTypes.func,
  umoList: PropTypes.instanceOf(List),
  isSortMode: PropTypes.bool,
  pageNumber: PropTypes.number,
  pageTotal: PropTypes.number,
  onPageChange: PropTypes.func,
  toggleCompareView: PropTypes.func,
};

export default injectIntl(UMOGalleryHeader);




// WEBPACK FOOTER //
// ./src/js/components/UMOGallery/UMOGalleryHeader.jsx